export const ROLES = {
  CUSTOMER: "customer",
  SUPPORT: "support",
  COMPLIANCE: "compliance",
  OPERATIONS: "operations",
  ADMIN: "admin",
};

// Mirrors backend role dependencies. Frontend guards improve navigation only;
// the API remains the authority for every protected operation.
export const ADMIN_PORTAL_ROLES = [ROLES.ADMIN];
export const OPS_EXECUTION_ROLES = [ROLES.ADMIN];

export function hasRole(role, allowed) {
  return allowed.includes(String(role || "").toLowerCase());
}
